export default function Container({ children, className = "" }) {
  return <div className={`u-container ${className}`}>{children}</div>;
}
